export default __webpack_public_path__ + "static/media/ap logo main.25727500.png";